<template>
  <div class="whitelist-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="姓名/身份证号"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="社区">
          <el-select v-model="searchForm.communityId" placeholder="全部" clearable filterable style="width: 180px">
            <el-option v-for="c in communities" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
<!--        <el-form-item style="float: right;">-->
<!--          <el-button type="success" icon="el-icon-upload2" @click="openImportDialog">批量导入</el-button>-->
<!--        </el-form-item>-->
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column label="姓名" min-width="70">
          <template slot-scope="{ row }">
            <span>{{ row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号" min-width="100">
          <template slot-scope="{ row }">
            <span>{{ maskIdCard(row.idCardNo) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="100">
          <template slot-scope="{ row }">
            <span>{{ maskPhone(row.phone) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属社区" min-width="50">
          <template slot-scope="{ row }">
            {{ getCommunityName(row.communityId) }}
          </template>
        </el-table-column>
        <el-table-column prop="personType" label="类型" width="100" ></el-table-column>
        <el-table-column prop="expireAt" label="过期时间" width="160" ></el-table-column>
<!--        <el-table-column prop="tags" label="标签" min-width="150">-->
<!--          <template slot-scope="{ row }">-->
<!--            <el-tag v-for="tag in parseTags(row.tags)" :key="tag" size="mini" style="margin-right:4px;">-->
<!--              {{ tag }}-->
<!--            </el-tag>-->
<!--            <span v-if="!row.tags">-</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="{ row }">
<!--            <el-button size="mini" type="primary" @click="openEditTags(row)">编辑标签</el-button>-->
            <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 批量导入弹窗 -->
    <el-dialog title="批量导入白名单" :visible.sync="importVisible" width="600px">
      <el-alert
        title="请按以下格式准备数据，每行一条记录，字段用逗号分隔：姓名,身份证号,手机号,社区ID"
        type="info"
        :closable="false"
        style="margin-bottom: 12px;"
      ></el-alert>
      <el-input
        v-model="importText"
        type="textarea"
        :rows="10"
        placeholder="示例：&#10;张三,330302199001011234,13800138000,1&#10;李四,330302199205061234,13900139000,1"
      ></el-input>
      <div slot="footer">
        <el-button @click="importVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="doImport">开始导入</el-button>
      </div>
    </el-dialog>

    <!-- 编辑标签弹窗 -->
    <el-dialog title="编辑标签" :visible.sync="tagsVisible" width="400px">
      <el-form>
        <el-form-item label="标签">
          <el-input v-model="tagInput" placeholder="用逗号分隔，如：低保,残疾"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="tagsVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="doUpdateTags">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getWhitelist, batchImportWhitelist, deleteWhitelist, updateWhitelistTags } from '@/api/whitelist'
import {getCommunityList, getCommunityNameList} from '@/api/community'

export default {
  name: 'WhitelistList',
  data() {
    return {
      searchForm: { keyword: '', communityId: null },
      tableData: [],
      communities: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      importVisible: false,
      importText: '',
      tagsVisible: false,
      tagInput: '',
      currentRow: null,
      submitting: false
    }
  },
  mounted() {
    this.loadCommunities()
    this.loadData()
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await getCommunityNameList()
        const list = res.records || res.list || res.items || res || []
        this.communities = Array.isArray(list) ? list : []
      } catch (e) {}
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getWhitelist(this.searchForm.keyword, this.searchForm.communityId, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm = { keyword: '', communityId: null }; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    getCommunityName(id) {
      const c = this.communities.find(x => x.id === id)
      return c ? c.name : '-'
    },
    parseTags(tags) {
      if (!tags) return []
      return tags.split(',').filter(Boolean)
    },
    maskName(n) { return n ? n.substring(0, 1) + '**' : '-' },
    maskIdCard(id) {
      if (!id) return '-'
      const s = String(id)
      return s.length > 8 ? s.substring(0, 4) + '**********' + s.substring(s.length - 4) : '********'
    },
    maskPhone(p) { return p ? String(p).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : '-' },
    openImportDialog() { this.importText = ''; this.importVisible = true },
    async doImport() {
      if (!this.importText.trim()) return this.$message.warning('请输入导入数据')
      const lines = this.importText.trim().split('\n').filter(l => l.trim())
      const list = lines.map(line => {
        const parts = line.split(',').map(s => s.trim())
        return {
          realName: parts[0] || '',
          idCardNo: parts[1] || '',
          phone: parts[2] || '',
          communityId: parts[3] ? Number(parts[3]) : null
        }
      })
      this.submitting = true
      try {
        await batchImportWhitelist(list)
        this.$message.success(`成功导入 ${list.length} 条记录`)
        this.importVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    openEditTags(row) {
      this.currentRow = row
      this.tagInput = row.tags || ''
      this.tagsVisible = true
    },
    async doUpdateTags() {
      this.submitting = true
      try {
        await updateWhitelistTags(this.currentRow.id, this.tagInput)
        this.$message.success('标签已更新')
        this.tagsVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    handleDelete(row) {
      this.$confirm(`确认删除该白名单记录吗？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteWhitelist(row.id)
          this.$message.success('删除成功')
          this.loadData()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.whitelist-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>
